module.exports = __webpack_public_path__ + "static/media/cherryBlossomsRight.7e58aab4.png";